import { USE_MOCKS } from '../config/serviceConfig';
import { fitAnatomyMock } from './mock/fitAnatomy.mock';
import { fitAnatomyReal } from './real/fitAnatomy.real';
import type { IFitAnatomyService } from './interfaces/IFitAnatomyService';

export const fitAnatomyService: IFitAnatomyService = USE_MOCKS
  ? fitAnatomyMock
  : fitAnatomyReal;
